import { OrderStatus } from "../../data/BaseEntity";

export const StatusColors = {
  [OrderStatus.INITIAL]: "#f2d97b",
  [OrderStatus.CONFIRMED]: "#a8d5b2",
  [OrderStatus.CHECKED_IN]: "#3F88C5",
  [OrderStatus.PAID]: "#a9c8e8",
  [OrderStatus.CANCELLED]: "#6b7280",
  [OrderStatus.LIST_SENT]: "#efc96f",
  [OrderStatus.FOR_ADVANCE_PAYMENT]: "#efb08a",
  [OrderStatus.ADVANCE_PAID]: "#b9d8a2",
  [OrderStatus.TO_CANCEL]: "#f2b4b4",
  [OrderStatus.CANCELLATION_SENT]: "#d9dde3",
  [OrderStatus.TO_ORDER]: "#8fcbbd",
  [OrderStatus.BOOKING_IN_PROGRESS]: "#c7bfe3",
  [OrderStatus.CHANGE_REQUIRED]: "#f0c08c",
  [OrderStatus.TO_MOVE]: "#cfa8d8",
} as const;
